import { useEffect, useState, useRef, useLayoutEffect } from 'react';

const OPTIONS = {
	root: null,
	rootMargin: '0px',
	threshold: 1.0
};

const FALLBACK = '<b>NO IMAGE LOADED</b>';

const HAS_INTERSECTION_OBSERVER = 'IntersectionObserver' in window;

const STYLE = { width: 'inherit' };

const ExternalSVG = ({ url, className, lazy = true }) => {
	const ref = useRef();
	const [svg, setSVG] = useState(null);
	const [visible, setVisible] = useState(!lazy || !HAS_INTERSECTION_OBSERVER);
	useEffect(() => {
		if (!lazy || !HAS_INTERSECTION_OBSERVER) return;
		const { current } = ref;
		const observer = new IntersectionObserver(([entry]) => {
			setVisible(entry.isIntersecting);
		}, OPTIONS);
		if (current) {
			observer.observe(current);
			return () => observer.unobserve(current);
		}
	}, [ref, lazy]);
	useEffect(() => {
		if (visible && !svg)
			fetch(url)
				.then(response => {
					if (!response.ok || response.status !== 200) throw Error('Not okay');
					return response;
				})
				.then(response => response.text())
				.then(v =>
					v.includes('<svg') && v.includes('/svg>')
						? v.substring(v.indexOf('<svg'), v.lastIndexOf('/svg>') + 5)
						: ''
				)
				.then(v => {
					if (ref.current) setSVG(v); // saves a kitten by checking if still mounted
				})
				.catch(() => {
					if (ref.current) setSVG(FALLBACK); // FIXME, set error state, show some image?
				});
	}, [visible, svg, url, ref]);

	useLayoutEffect(() => {
		if (ref?.current?.firstElementChild && className) {
			ref.current.firstElementChild.classList.add(...className.split(' '));
		}
	});

	return (
		// eslint-disable-next-line react/no-danger
		<div style={STYLE} ref={ref} dangerouslySetInnerHTML={{ __html: svg }} />
	);
};

export default ExternalSVG;
